import { bimCategoriesAPI } from "@/views/BimCategories/services/api";

export const getBimCategories = async () => {
  try {
    const res = await bimCategoriesAPI.getList();
    return res?.data;
  } catch (e) {}
};

export const getBimTypes = async (bim_category_id) => {
  try {
    const res = await bimCategoriesAPI.getTypes(bim_category_id);
    return res?.data;
  } catch (e) {}
};

export const getBimParams = async (bim_type_id) => {
  try {
    const res = await bimCategoriesAPI.getParams(bim_type_id);
    return res?.data;
  } catch (e) {}
};

export const getAllBimParams = async () => {
  try {
    const res = await bimCategoriesAPI.getAllParams();
    return res?.data;
  } catch (e) {}
};

export const getFloorParamTypes = async () => {
  try {
    const res = await bimCategoriesAPI.getFloorParamTypes();
    return res?.data;
  } catch (e) {}
};

export const importBimJson = async (file) => {
  try {
    const res = await bimCategoriesAPI.importJson(file);
    return res;
  } catch (e) {}
};

export const importBimExcelDict = async (file) => {
  const res = await bimCategoriesAPI.importExcelDict(file);
  return res;
};

export const saveBimType = async (data) => {
  try {
    const res = await bimCategoriesAPI.saveType(data);
    return res;
  } catch (e) {}
};

export const deleteBimType = async (bim_type_id) => {
  try {
    const res = await bimCategoriesAPI.deleteType(bim_type_id);
    return res;
  } catch (e) {}
};

export const saveBimTypeParam = async (data) => {
  try {
    const res = await bimCategoriesAPI.saveTypeParam(data);
    return res;
  } catch (e) {}
};

export const deleteBimTypeParam = async (bim_type_param_id) => {
  try {
    const res = await bimCategoriesAPI.deleteTypeParam(bim_type_param_id);
    return res;
  } catch (e) {}
};

// Групповые действия
export const getParamsByGroup = async (bim_type_ids) => {
  try {
    const res = await bimCategoriesAPI.getParamsByGroup(bim_type_ids);
    return res?.data;
  } catch (e) {}
};

export const deleteParamFromGroup = async (bim_param_id, bim_type_ids) => {
  try {
    const res = await bimCategoriesAPI.deleteParamFromGroup(bim_param_id, bim_type_ids);
    return res;
  } catch (e) {}
};

export const setParamsSelectedGroup = async (bim_param_ids, bim_type_ids, is_active) => {
  try {
    const res = await bimCategoriesAPI.setParamsSelectedGroup(bim_param_ids, bim_type_ids, is_active);
    return res;
  } catch (e) {}
};

